import { VStack } from "@chakra-ui/react";
import Layout from "../Layout/Layout";
import IntentTable from "./IntentTable";

const Intent = () => {
  return (
      <VStack
        h="100%"
        spacing={2}
        justifyContent={"space-between"}
        borderRadius="md"
      >
        <IntentTable />
      </VStack>
  );
};

export default Intent;
